import { NgModule } from '@angular/core';
import { NbCardModule, NbIconModule, NbInputModule, NbToggleModule, NbActionsModule, NbSpinnerModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';

import { ThemeModule } from '../../@theme/theme.module';
import { routedComponents, LicenceKeysRoutingModule } from './licencekeys-routing.module';
import { FormsModule } from '@angular/forms';
import { NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { EditLicenceKeyComponent } from './edit-licencekey/edit-licencekey.component';


@NgModule({
  imports: [
    NbCardModule,
    NbIconModule,
    NbInputModule,
    ThemeModule,
    LicenceKeysRoutingModule,
    Ng2SmartTableModule,
    FormsModule,
    NbToggleModule,
    NgbModule,
    NgMultiSelectDropDownModule, 
    NbActionsModule,
    NbSpinnerModule,
  ],
  entryComponents: [
    EditLicenceKeyComponent,
  ],
  declarations: [
    EditLicenceKeyComponent,
    ...routedComponents,
  ],
})
export class LicenceKeyModule { }
